import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Keeps every /esign route on the OLD Urbanist typeface after the rest of the
 * CRM moved to Inter (CG, 2026-09-24: change the font, "exempt eSign").
 *
 * Why a class on <html> and not a wrapper <div>: eSign opens modals and the PDF
 * signature picker, and the browser print/PDF path renders off the document
 * root, so a wrapper would leave those on the new font and the signed contract
 * would not match the one on screen. The class is the seam the exemption rule
 * in src/index.css hangs off.
 *
 * Mirrors ScrollToTop: useLayoutEffect so the swap happens BEFORE paint and no
 * one sees a frame of Inter on a contract.
 */
const EsignFontScope = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Covers both the authenticated /esign/* pages and the public
    // /esign/sign/:token signing page.
    const isEsign = pathname === '/esign' || pathname.startsWith('/esign/');
    document.documentElement.classList.toggle('esign-legacy-font', isEsign);
    return () => document.documentElement.classList.remove('esign-legacy-font');
  }, [pathname]);

  return null;
};

export default EsignFontScope;
